(function (window, document) {
  "use strict";

  var COOKIE_NAME = "moko_operations_fragments_nonce";
  var LOGIN_HINT_COOKIE = "wp-moko_user_time";
  var NONCE_ACTION = "moko_frontend_operations_fragments_nonce";
  var FRAGMENT_ACTION = "moko_frontend_operations_fragments";
  var MAX_BATCH_SIZE = 20;
  var MAX_PAYLOAD_BYTES = 32768;
  var bootstrapPromise = null;

  var moko = window.moko = window.moko || {};

  function hasLoginHint() {
    return document.cookie.split(";").some(function (item) {
      return item.trim().indexOf(LOGIN_HINT_COOKIE + "=") === 0;
    });
  }

  function getCookie(name) {
    var prefix = name + "=";
    var value = document.cookie.split(";").filter(function (item) {
      return item.trim().indexOf(prefix) === 0;
    })[0];

    if (!value) {
      return "";
    }
    try {
      return decodeURIComponent(value.trim().slice(prefix.length));
    } catch (error) {
      return "";
    }
  }

  function removeCookie(name) {
    var path = moko.frontend_operations_fragments_cookie_path ||
      moko.frontend_admin_fragments_cookie_path || "/";
    var domain = moko.frontend_operations_fragments_cookie_domain ||
      moko.frontend_admin_fragments_cookie_domain || "";
    var cookie = name + "=; Max-Age=0; path=" + path + "; SameSite=Lax";
    if (domain) {
      cookie += "; domain=" + domain;
    }
    document.cookie = cookie;
  }

  function byteLength(value) {
    try {
      return new Blob([value]).size;
    } catch (error) {
      return unescape(encodeURIComponent(value)).length;
    }
  }

  function fragmentAttribute(element, name, legacyName) {
    return element.getAttribute(name) || element.getAttribute(legacyName) || "";
  }

  function setFragmentState(element, state) {
    if (element.getAttribute("data-operations-fragment") ||
        element.classList.contains("js-moko-operations-fragment")) {
      element.setAttribute("data-operations-fragment-state", state);
      element.removeAttribute("data-admin-fragment-state");
      return;
    }
    // 旧placeholderだけは旧state属性を維持する。
    element.setAttribute("data-admin-fragment-state", state);
    element.removeAttribute("data-operations-fragment-state");
  }

  function clearFragmentState(element) {
    element.removeAttribute("data-operations-fragment-state");
    element.removeAttribute("data-admin-fragment-state");
  }

  function placeholders(root) {
    var nodes = [];
    if (root && root.nodeType === 1 &&
        root.matches(".js-moko-operations-fragment, .js-moko-admin-fragment")) {
      nodes.push(root);
    }
    if (root && root.querySelectorAll) {
      nodes = nodes.concat(Array.prototype.slice.call(
        root.querySelectorAll(".js-moko-operations-fragment, .js-moko-admin-fragment")
      ));
    }
    return nodes.filter(function (node) {
      var state = fragmentAttribute(
        node,
        "data-operations-fragment-state",
        "data-admin-fragment-state"
      );
      return state !== "loaded" && state !== "pending" && state !== "invalid";
    });
  }

  function request(action, body, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", moko.ajaxurl, true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) {
        return;
      }
      var response = null;
      try {
        response = JSON.parse(xhr.responseText);
      } catch (error) {
        callback(false, xhr.status, null);
        return;
      }
      callback(xhr.status >= 200 && xhr.status < 300 && response.success, xhr.status, response);
    };
    xhr.onerror = function () {
      callback(false, 0, null);
    };
    xhr.send("action=" + encodeURIComponent(action) + "&" + body);
  }

  function bootstrap(callback) {
    if (bootstrapPromise) {
      bootstrapPromise.push(callback);
      return;
    }

    bootstrapPromise = [callback];
    request(NONCE_ACTION, "", function (success, status, response) {
      var callbacks = bootstrapPromise;
      bootstrapPromise = null;
      callbacks.forEach(function (done) {
        done(success && response && response.data &&
          response.data.issued === true && getCookie(COOKIE_NAME) !== "");
      });
    });
  }

  function requestItem(item) {
    return {
      requestId: item.requestId,
      provider: item.provider,
      context: item.context
    };
  }

  function serializedBatch(batch) {
    return JSON.stringify(batch.map(requestItem));
  }

  function hideResponsivePreviewInIframe(root) {
    if (window === window.parent || !root || !root.querySelector) {
      return;
    }
    var control = root.querySelector("[data-moko-responsive-preview]");
    if (control) {
      control.style.display = "none";
    }
    Array.prototype.forEach.call(document.getElementsByClassName("moko-ad"), function (ad) {
      ad.style.display = "none";
    });
  }

  function sendBatch(batch, retry, done) {
    var nonce = getCookie(COOKIE_NAME);
    if (!nonce) {
      bootstrap(function (ready) {
        if (!ready) {
          done(false);
          return;
        }
        sendBatch(batch, retry, done);
      });
      return;
    }

    request(
      FRAGMENT_ACTION,
      "nonce=" + encodeURIComponent(nonce) +
        "&fragments=" + encodeURIComponent(serializedBatch(batch)),
      function (success, status, response) {
        if (!success && status === 403 && !retry) {
          removeCookie(COOKIE_NAME);
          bootstrap(function (ready) {
            if (ready) {
              sendBatch(batch, true, done);
            } else {
              done(false);
            }
          });
          return;
        }

        if (!success || !response || !response.data) {
          done(false);
          return;
        }
        if (!Array.isArray(response.data.fragments)) {
          done(false);
          return;
        }
        var returnedRequestIds = {};
        response.data.fragments.forEach(function (fragment) {
          if (!fragment || typeof fragment !== "object") {
            return;
          }
          var node = batch.filter(function (item) {
            return item.requestId === String(fragment.requestId);
          })[0];
          if (node && node.element && document.documentElement.contains(node.element)) {
            returnedRequestIds[node.requestId] = true;
            if (typeof fragment.html === "string") {
              node.element.innerHTML = fragment.html;
              hideResponsivePreviewInIframe(node.element);
            }
            setFragmentState(node.element, "loaded");
          }
        });
        // 権限不足・未知providerなどで省略された項目も、空の確定状態にする。
        batch.forEach(function (item) {
          if (item.element && document.documentElement.contains(item.element) &&
              fragmentAttribute(
                item.element,
                "data-operations-fragment-state",
                "data-admin-fragment-state"
              ) === "pending" &&
              !returnedRequestIds[item.requestId]) {
            setFragmentState(item.element, "loaded");
          }
        });
        done(true);
      }
    );
  }

  function makeBatches(nodes) {
    var batches = [];
    var batch = [];
    nodes.forEach(function (element, index) {
      var context;
      try {
        context = JSON.parse(fragmentAttribute(
          element,
          "data-operations-context",
          "data-admin-context"
        ) || "{}");
      } catch (error) {
        setFragmentState(element, "invalid");
        return;
      }
      if (!context || typeof context !== "object" || Array.isArray(context)) {
        setFragmentState(element, "invalid");
        return;
      }
      var item = {
        requestId: String(index),
        provider: fragmentAttribute(
          element,
          "data-operations-fragment",
          "data-admin-fragment"
        ),
        context: context,
        element: element
      };
      if (byteLength(serializedBatch([item])) > MAX_PAYLOAD_BYTES) {
        setFragmentState(element, "invalid");
        return;
      }
      var candidate = batch.concat([item]);
      if (batch.length >= MAX_BATCH_SIZE ||
          byteLength(serializedBatch(candidate)) > MAX_PAYLOAD_BYTES) {
        if (batch.length) {
          batches.push(batch);
        }
        batch = [item];
      } else {
        batch = candidate;
      }
    });
    if (batch.length) {
      batches.push(batch);
    }
    return batches;
  }

  function loadOperationsFragments(root) {
    var nodes = placeholders(root || document);
    if (!nodes.length || !hasLoginHint() || !moko.ajaxurl) {
      return;
    }

    nodes.forEach(function (node) {
      setFragmentState(node, "pending");
    });
    makeBatches(nodes).forEach(function (batch) {
      sendBatch(batch, false, function (success) {
        if (!success) {
          batch.forEach(function (item) {
            if (fragmentAttribute(
              item.element,
              "data-operations-fragment-state",
              "data-admin-fragment-state"
            ) === "pending") {
              clearFragmentState(item.element);
            }
          });
        }
      });
    });
  }

  moko.loadOperationsFragments = loadOperationsFragments;
  // 旧公開APIを維持する。
  moko.loadAdminFragments = loadOperationsFragments;

  document.addEventListener("DOMContentLoaded", function () {
    loadOperationsFragments(document);
  });
  document.addEventListener("customDOMContentLoaded", function (event) {
    var detail = event.detail || {};
    loadOperationsFragments(detail.root || detail.modalWindow || document);
  });
  if (window.jQuery) {
    window.jQuery(document).on("facetwp-loaded", function () {
      loadOperationsFragments(document);
    });
  }
})(window, document);
